<div class="select-document">
  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'select document' | translate: ['tmc.admin.tasks.select-document-dialog.title', translationService.language]}}
    </h2>
    <i class="horizontal-divider"></i>

    <div class="dialog-content">

      <sc-padding>

        <div class="table-container">
          <table class="w-100 mat-table-selection" mat-table [dataSource]="dataSource">
            <!-- Displays a "no data" row when no rows are available. Prevents the table from looking nasty-->
            <ng-container matColumnDef="noRecord">
              <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef>
                {{'no data available' | translate: ['shared.tmc-table.nodata', translationService.language]}}</td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell mat-header *matHeaderCellDef>{{'name'|
                translate:['tmc.admin.tasks.select-document-dialog.table.column.name', translationService.language]}}
              </th>
              <td mat-cell *matCellDef="let document"> {{document.nameDictionaryKey |
                translate:[document.nameDictionaryKey , translationService.language]}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

            <tr mat-row *matRowDef="let document; columns: columnsToDisplay" [ngClass]="getRowStyles(document)"
              (click)="toggleSelection(document)"></tr>

            <tr [class.hide]="!showNoData()" mat-footer-row *matFooterRowDef="['noRecord']"></tr>

          </table>
        </div>

      </sc-padding>

    </div>

    <i class="horizontal-divider"></i>
    <div>
      <sc-padding>
        <sc-flex>
          <sc-content-spacer [grow]="true"></sc-content-spacer>
          <button mat-stroked-button type="button" (click)="cancel()" class="cancel-button">{{'cancel' |
            translate:['tmc.admin.tasks.select-document-dialog.action.close', translationService.language]}}</button>
          <sc-content-spacer></sc-content-spacer>
          <button mat-flat-button type="button" class="confirm-button" (click)="selectDocument()"
            [disabled]="isSelectDocumentDisabled()"
            [matTooltip]="'select document' | translate:['tmc.admin.tasks.select-document-dialog.action.select', translationService.language]">
            {{'select document' | translate:['tmc.admin.tasks.select-document-dialog.action.select',
            translationService.language]}}
          </button>
        </sc-flex>
      </sc-padding>
    </div>
  </div>
</div>